<div class="app-pos-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <div class="title-main">ใส่ PIN</div>
      <div class="title-description">กรุณาใส่ PIN เพื่อปลดล็อค</div>
    </div>
    <div class="header-action">
      <a mat-button href="javascript:void(0)" (click)="forgotPin()">ลืมรหัส PIN?</a>
      <!-- <button type="button" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button> -->
    </div>
  </div>
  <div class="dialog-body">
    <form [formGroup]="dialogForm" (submit)="onSubmit()">
      <div class="form-container">
        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="showErrorText">
              <p class="text-danger text-center">{{ errorText }}</p>
            </ng-container>
            <!-- <ng-container>
              <div class="reset-pin-box">
                <a href="javascript:void(0)" (click)="resetPinInput()">รีเซ็ตรหัส PIN</a>
              </div>
            </ng-container> -->
          </div>
          <div class="col-12">
            <div class="pin-container">
              <input
                id="position_1"
                type="password"
                mask="9"
                class="input-pin"
                (click)="selectAllOnClick($event)"
                formControlName="position_1"
              />
              <input
                id="position_2"
                type="password"
                mask="9"
                class="input-pin"
                (click)="selectAllOnClick($event)"
                formControlName="position_2"
              />
              <input
                id="position_3"
                type="password"
                mask="9"
                class="input-pin"
                (click)="selectAllOnClick($event)"
                formControlName="position_3"
              />
              <input
                id="position_4"
                type="password"
                mask="9"
                class="input-pin"
                (click)="selectAllOnClick($event)"
                formControlName="position_4"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <button type="button" mat-raised-button (click)="close()">ปิด</button>
        <button type="submit" mat-raised-button color="accent">ยืนยัน</button>
      </div>
    </form>
  </div>
</div>
